import { z } from 'zod'

const OrderItemSchema = z.object({
  coupon: z.string().optional(),
  couponId: z.number().optional(),
  productOption: z.string(),
  productOptionId: z.number(),
  productPromotion: z.string().optional(),
  productPromotionId: z.number().optional(),
  quantity: z.number(),
})

const ShippingSchema = z.object({
  shippingPresetId: z.number(),
  shippingCoupon: z.string().optional(),
  orderItems: z.array(OrderItemSchema),
})

const CustomerAddressSchema = z.object({
  basicAddress: z.string().min(1),
  customerTemplateAddress: z.string(),
  detailedAddress: z.union([z.string(), z.number()]),
  isDefault: z.boolean(),
  message: z.string(),
  mobileNumber: z
    .string()
    .min(1)
    .regex(/^(010|011|016|018|019)\d{7,8}$/),
  name: z.string(),
  postNumber: z.string().min(1),
  templateName: z.string(),
})

export const OrderFormSchema = z.object({
  amount: z.number(),
  coupon: z.string().optional(),
  couponId: z.number().optional(),
  customerAddress: CustomerAddressSchema,
  isUseAllMileage: z.boolean(),
  mileage: z.string(),
  payMethodType: z.string(),
  shippings: z.array(ShippingSchema),
})

export type OrderItem = {
  coupon?: string
  couponId?: number
  productOption: string
  productOptionId: number
  productPromotion?: string
  productPromotionId?: number
  quantity: number
}

export type OrderFormType = {
  amount: number
  coupon?: string
  couponId?: number
  customerAddress: {
    basicAddress: string
    customerTemplateAddress: string
    detailedAddress: string
    isDefault: boolean
    message?: string
    mobileNumber: string
    name: string
    postNumber: string
    templateName: string
  }
  isUseAllMileage: boolean
  // api expects a number, but the form sends a string
  // api 에서는 number, form 에서는 string
  mileage: string
  payMethodType: string
  shippings: {
    shippingPresetId: number
    shippingCoupon?: string
    orderItems: OrderItem[]
  }[]
}
